window.DrvDrag = {
  ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
    document.addEventListener('shopify:section:load', fn);
  },

  scroll(el, stepOf) {
    if (!el || el.dataset.drvDrag) return;
    el.dataset.drvDrag = '1';
    let active = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('dragstart', (e) => e.preventDefault());
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      active = true;
      moved = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });
    el.addEventListener('pointermove', (e) => {
      if (!active) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        el.setPointerCapture(e.pointerId);
        el.style.scrollSnapType = 'none';
      }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    const end = () => {
      if (moved) {
        el.style.scrollSnapType = '';
        const step = stepOf ? stepOf() : el.firstElementChild ? el.firstElementChild.offsetWidth + (parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap) || 0) : 0;
        if (step) el.scrollTo({ left: Math.round(el.scrollLeft / step) * step, behavior: 'smooth' });
      }
      active = false;
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  },

  swipe(el, onPrev, onNext, ignore) {
    if (!el || el.dataset.drvSwipe) return;
    el.dataset.drvSwipe = '1';
    let x0 = null, y0 = 0;
    el.addEventListener('dragstart', (e) => e.preventDefault());
    el.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      if (ignore && e.target.closest(ignore)) return;
      x0 = e.clientX;
      y0 = e.clientY;
    });
    el.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      const dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      (dx > 0 ? onPrev : onNext)();
    });
    el.addEventListener('pointercancel', () => { x0 = null; });
    window.DrvDrag.wheel(el, onPrev, onNext);
  },

  scrollsNatively(el) {
    if (el.scrollWidth - el.clientWidth < 2) return false;
    return /(auto|scroll)/.test(getComputedStyle(el).overflowX);
  },

  wheel(el, onPrev, onNext) {
    if (!el || el.dataset.drvWheel) return;
    el.dataset.drvWheel = '1';
    let sum = 0;
    let locked = false;
    let idle = 0;
    el.addEventListener('wheel', (e) => {
      if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      if (window.DrvDrag.scrollsNatively(el)) return;
      e.preventDefault();
      clearTimeout(idle);
      idle = setTimeout(() => {
        sum = 0;
        locked = false;
      }, 200);
      if (locked) return;
      sum += e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
      if (Math.abs(sum) < 30) return;
      locked = true;
      (sum > 0 ? onNext : onPrev)();
    }, { passive: false });
  }
};

(() => {
  const slides = document.querySelector('.drv-hero slideshow-slides');
  if (!slides) return;
  let t;
  slides.addEventListener('scroll', () => {
    clearTimeout(t);
    t = setTimeout(() => {
      const comp = slides.closest('slideshow-component');
      if (comp && comp.hasAttribute('dragging')) return;
      let nearest = null;
      for (const s of slides.children) {
        if (nearest === null || Math.abs(s.offsetLeft - slides.scrollLeft) < Math.abs(nearest - slides.scrollLeft)) {
          nearest = s.offsetLeft;
        }
      }
      if (nearest !== null && Math.abs(slides.scrollLeft - nearest) > 2) {
        slides.scrollTo({ left: nearest, behavior: 'smooth' });
      }
    }, 200);
  }, { passive: true });
})();
